import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { ToastContainer, toast } from 'react-toastify';
import loading from "../../assets/images/common/loading.gif";
import axios from "axios";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import excelIcon from "../../assets/icons/excel.png";
import { Tooltip } from '@mui/material';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";
import AppDataGrid from '../../components/common/AppDataGrid';
const Studentattendancereport = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = JSON.parse(userData);
    const [classes, setClasses] = useState([]);
    const [sections, setSection] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [studentsData, setStudentsData] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [form, setForm] = useState({
        class_id: "",
        section_id: "",
        is_present: "",
        period_id: "",
    });
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [searchQuery, setSearchQuery] = useState('');
    const searchableColumns = [
        "admission_number",
        "student_name",
        "class_name",
        "section_name",
        "father_name",
        "dob",
        "date_of_join",
        "gender",
        "caste",
        "primary_contact",
        "attendance_count",
        "father_phone_number",
        "total_working_days",
        "total_present",
        "total_absent"
    ];


    const exportToExcel = () => {
        if (studentsData.length === 0) {
            toast.error("No data available to export.");
            return;
        }

        // Format headers
        const headersMap = {
            admission_number: "Admission Number",
            student_name: "Student Name",
            class_name: "Class",
            section_name: "Section",
            father_name: "Father Name",
            father_phone_number: "Mobile Number",
            total_working_days: "Working Days",
            total_present: "Present",
            total_absent: "Absent"
        };

        // Prepare data for export
        const exportData = studentsData.map(student => {
            const {
                dob,
                date_of_join,
                gender,
                admission_number,
                ...rest
            } = student;

            const filtered = {
                admission_number: student.admission_number,
                student_name: student.student_name,
                class_name: student.class_name,
                section_name: student.section_name,
                father_name: student.father_name,
                father_phone_number: student.father_phone_number,
                total_working_days: student.total_working_days,
                total_present: student.total_present,
                total_absent: student.total_absent
            };

            return filtered;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Rename headers
        const header = Object.keys(exportData[0]);
        XLSX.utils.sheet_add_aoa(worksheet, [header.map(h => headersMap[h] || h)], { origin: 'A1' });

        // Remove timezone from date strings
        Object.keys(worksheet).forEach((key) => {
            if (key[0] !== '!') {
                const cell = worksheet[key];
                if (typeof cell.v === 'string' && cell.v.includes('T')) {
                    cell.v = cell.v.split('T')[0]; // keep only date part
                }
            }
        });

        // Set column widths
        worksheet['!cols'] = header.map(key => {
            const headerText = headersMap[key] || key;
            const columnLengths = exportData.map(d => (d[key] != null ? d[key].toString().length : 0));
            const maxDataLen = columnLengths.length > 0 ? Math.max(...columnLengths) : 0;

            return { wch: Math.max(headerText.length, maxDataLen) + 2 };
        });


        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Student Attendance Report");
        XLSX.writeFile(workbook, `student_attendance_type_report_${new Date().toISOString().split('T')[0]}.xlsx`);
    };



    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredRecords = (studentsData || []).filter((student) => {
        return searchableColumns.some((column) => {
            const value = student[column];

            if (value) {
                // Handle "DOB" by manually formatting it to "DD-MM-YYYY"
                if (column === "dob" && student.dob) {
                    const formattedDOB = student.dob.split(" ")[0].split("-").reverse().join("-");
                    return formattedDOB.includes(searchQuery);
                }
                // Handle "Admission Date" (date_of_join) by manually formatting it to "DD-MM-YYYY"
                if (column === "date_of_join" && student.date_of_join) {
                    const formattedAdmissionDate = student.date_of_join.split(" ")[0].split("-").reverse().join("-");
                    return formattedAdmissionDate.includes(searchQuery);
                }
                // Handle other columns as normal strings
                return String(value).toLowerCase().includes(searchQuery.toLowerCase());
            }
            return false;
        });
    });

    const exportToPDF = () => {
        if (filteredRecords.length === 0) {
            toast.error("No data available to export.");
            return;
        }

        const doc = new jsPDF();
        doc.text("Student Attendance Report", 14, 10);

        const tableColumn = ["Admission Number", "Student Name", "Class", "Section", "Father Name", "Mobile Number", "Working Days", "Present", "Absent"];
        const tableRows = [];

        filteredRecords.forEach((row) => {
            tableRows.push([
                row.admission_number || "",
                row.student_name || "",
                row.class_name || "",
                row.section_name || "",
                row.father_name || "",
                row.father_phone_number || "",
                row.total_working_days || "",
                row.total_present || "",
                row.total_absent || ""
            ]);
        });

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });

        doc.save(`student_attendance_type_report_${new Date().toISOString().split('T')[0]}.pdf`);
    };


    const fetchClasses = async () => {
        try {
            const response = await axios.post(baseUrl + "/classes/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setClasses(response.data)
        } catch (error) {
            console.log("Error fetching class name:", error);
        }
    };

    useEffect(() => {
        fetchSections(form.class_id || 0);
    }, [form.class_id]);

    const fetchSections = async (class_id) => {
        try {
            const response = await axios.post(baseUrl + "/Sections/", {
                action: "DROPDOWNREAD",
                class_id: class_id,
                school_id: userObj.school_id,
                academic_year_id: userObj.academic_year_id
            });
            setSection(response.data);
        } catch (error) {
            console.log("Error fetching section name:", error);
        }
    };

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const getStartAndEndOfWeek = () => {
        const currentDate = new Date();
        const currentDayOfWeek = currentDate.getDay();
        const daysToSubtract = currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;
        const startOfWeek = new Date(currentDate);
        startOfWeek.setDate(currentDate.getDate() - daysToSubtract);
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        return { startOfWeek, endOfWeek };
    };

    const fetchStudentsData = async () => {
        if (form.period_id) {
            let formattedFromDate = null;
            let formattedToDate = null;

            if (form.period_id === "Date Range") {
                formattedFromDate = formatDate(fromDate);
                formattedToDate = formatDate(toDate);
            } else if (form.period_id === "This Week") {
                const { startOfWeek, endOfWeek } = getStartAndEndOfWeek();
                formattedFromDate = formatDate(startOfWeek);
                formattedToDate = formatDate(endOfWeek);
            }

            try {
                const response = await axios.post(baseUrl + "/Studentattdencetypereport/", {
                    action: "FILTER",
                    class_id: form.class_id || null,
                    section_id: form.section_id || null,
                    school_id: userObj.school_id,
                    is_present: form.is_present === "true",
                    type: form.period_id,
                    from_date: formattedFromDate,
                    to_date: formattedToDate
                });

                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                    setStudentsData(response.data);
                } else {
                    setStudentsData([]);
                }
            } catch (error) {
                console.log("Error fetching students data:", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchClasses();
    }, []);

    const handleInputChange = (event) => {
        const { id, value } = event.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!form.class_id && !form.period_id) {
            toast.error("Please Select Time Period and Class and Section.");
            return;
        }
        fetchStudentsData();
    };

   const columns = [
  {
    field: 'student_name',
    headerName: 'Student Name',
    flex: 1.5,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>
          {params.value && params.value.length > 15
            ? params.value.slice(0, 15) + '…'
            : params.value || ''}
        </span>
      </Tooltip>
    ),
  },
  {
    field: 'class_name',
    headerName: 'Class',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'section_name',
    headerName: 'Section',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'father_name',
    headerName: 'Father Name',
    flex: 1.5,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>
          {params.value && params.value.length > 16
            ? params.value.slice(0, 16) + '…'
            : params.value || ''}
        </span>
      </Tooltip>
    ),
  },
  {
    field: 'father_phone_number',
    headerName: 'Mobile Number',
    flex: 1.2,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'total_working_days',
    headerName: 'Working Days',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'total_present',
    headerName: 'Present',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'total_absent',
    headerName: 'Absent',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
];

    return (

        
           
                <div className='pageBody'>
                     <ToastContainer />
                    <Container fluid>
                        <Card>
                            <Card.Body className="hide-scrollbar">
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12}>
                                            <h6 className='commonSectionTitle'>Attendance Report</h6>
                                        </Col>
                                    </Row>
                                    <Row>

                                        <Col xs={12} md={6} lg={3} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>Type<span className="requiredStar">*</span></Form.Label>
                                                    <select
                                                        className="form-select"
                                                        id="period_id"
                                                        value={form.period_id}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="" disabled hidden>Select Type</option>
                                                        <option value="This Week">This Week</option>
                                                        <option value="This Month">This Month</option>
                                                        <option value="This Year">This Year</option>
                                                        <option value="Last Six Months">Last Six Months</option>
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Label>
                                                    Class<span className="requiredStar">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    id="class_id"
                                                    value={form?.class_id || ""}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="" disabled hidden>Select Class</option>
                                                    {(classes || [])
                                                        .filter(cls => cls?.is_active === "Active")
                                                        .map(cls => (
                                                            <option key={cls.class_id} value={cls.class_id}>
                                                                {cls.class_name}
                                                            </option>
                                                        ))}
                                                </Form.Select>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={3} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>Section<span className="requiredStar">*</span></Form.Label>
                                                    <select
                                                        className="form-select"
                                                        id="section_id"
                                                        value={form.section_id}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="" disabled hidden>Select Section</option>
                                                        {(sections || []).map((sectionItem) => (
                                                            <option key={sectionItem.section_id} value={sectionItem.section_id}>
                                                                {sectionItem.section_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="d-flex justify-content-end mt-4">
                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    className="btn-info clearBtn me-3" // adds space between buttons
                                                    onClick={() => {
                                                        setForm({
                                                            class_id: "",
                                                            period_id: "",
                                                            section_id: "",
                                                        });
                                                        setFromDate(null);
                                                        setToDate(null);
                                                        setSearchQuery('');
                                                        setStudentsData([]);
                                                    }}
                                                >
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="primary"
                                                    className="btn-success primaryBtn"
                                                >
                                                    Search
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </Card.Body>
                        </Card>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Search Input on the left */}
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                className="form-control form-control-sm w-25"
                                onChange={handleSearchChange}
                            /><div>
                                <Button className='btnMain' variant="success" onClick={exportToExcel} style={{ marginRight: "10px" }}>
                                    <img
                                        src={excelIcon}
                                        alt="Download Excel"
                                        style={{ width: "20px", marginRight: "5px" }}
                                    />

                                </Button>
                                <Button className="btnMain" variant="danger" onClick={exportToPDF}>
                                    <FaFilePdf style={{ marginRight: "5px" }} />
                                </Button>
                            </div>
                        </div>
                        <div className="commonTable height100 mt-2">
                            <div className="tableBody">
                                {isLoading ? (
                                    <div className="text-center">
                                        <img src={loading} alt="loading..." />
                                    </div>
                                ) : (
                                    <AppDataGrid
  rows={(filteredRecords.length ? filteredRecords : []).map((row, index) => ({
    id: row.student_id || index, // force id field
    ...row,
  }))}
  columns={columns}
  pageSizeOptions={[10, 20, 50]}
  showToolbar={false}
  pagination
  density="compact"
  maxHeight={400}
/>


                                )}
                            </div>
                        </div>

                    </Container>

                </div>
         
    );
}

export default Studentattendancereport;